import * as React from 'react';

export class SlackSvg extends React.Component<{}> {

  render() {
    return (
      <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 50 50"
          xmlSpace="preserve"
      >
        <g>
          <path
              fill="#3FB991"
              d="M17,31.2c-0.8-2.1-1.5-4.3-2.3-6.4c-0.1-0.1-0.1-0.3,0-0.4c1.9-1,3.7-2.1,5.9-1.9c0.2,0.2,0.5,0.3,0.6,0.6c0.7,2,1.6,3.9,1.9,6c0,
              0.1-0.1,0.3-0.2,0.4c-1.5,1-3.2,1.4-4.8,2C17.7,31.7,17.3,31.6,17,31.2z"
          />
          <path
              fill="#E8A721"
              d="M32.9,18.5c0.7,2.2,1.5,4.4,2.2,6.6c0,0.1,0,0.1,0,0.2c-0.1,0.1-0.1,0.3-0.3,0.4c-1.8,0.7-3.5,1.6-5.4,1.8c-0.1,
              0-0.3-0.1-0.4-0.2c-1.1-2.1-2-4.4-2.2-6.8c0-0.1,0.1-0.3,0.2-0.4c1.6-1.1,3.4-1.4,5.1-1.9C32.4,18.2,32.7,18.2,32.9,18.5z"
          />
          <path
              fill="#E01664"
              d="M29.2,27.1c0.1,0,0.1,0.1,0.2,0.1c0.2,0.1,0.5,0.2,0.6,0.4c0.6,1.6,1.5,3.2,1.4,5c0,0.1-0.1,0.2-0.3,0.3c-2.2,0.7-4.3,1.4-6.5,
              2.1c-0.1-0.1,0,0.1-0.1,0c-1.1-0.7-2.2-4.3-1.8-5.5c0-0.1,0-0.1,0.1-0.2c0.1-0.5,0.5-0.8,0.9-0.9c1.4-0.5,2.8-0.9,4.2-1.4C28.3,26.9,
              28.8,26.9,29.2,27.1z"
          />
          <path
              fill="#6FCADB"
              d="M27,20.3c0,0.1,0,0.1,0,0.2c-0.2,0.4-0.5,0.7-1,0.9c-1.3,0.5-2.6,1-3.9,1.4c-0.5,
              0.2-1.1,0.3-1.6-0.1c-0.3-0.1-0.7-0.2-0.8-0.6c-0.6-1.6-1.4-3.1-1.5-4.9c0-0.1,0.1-0.2,0.2-0.3c2.2-0.7,4.4-1.3,6.5-2c0.1,
              0,0.3,0,0.4,0.1C26.5,16.6,27.3,18.3,27,20.3z"
          />
          <path
              fill="#E8A721"
              d="M31.2,32.9c0-0.1,0-0.1,0.1-0.2c0.1-0.2,0.2-0.5,0.4-0.6c1.7-0.6,3.3-1.5,5.2-1.5c0.1,0,0.2,0.1,0.2,0.3c0.4,1.2,0.7,2.3,
              1.1,3.5c0.5,1.7-0.3,3.4-1.9,3.9c-1.6,0.6-3.3-0.2-4-2C31.9,35.2,31.6,34,31.2,32.9z"
          />
          <path
              fill="#371039"
              d="M22.7,29.5c0.6,1.8,1.3,3.7,1.9,5.5c0,0.1,0,0.1-0.1,0.1c0,0.1,0,0.2-0.1,0.2c-0.7,1-4.4,2.1-5.6,1.7c-0.1,0-0.1,
              0-0.1-0.1c-0.3-0.2-0.6-0.4-0.8-0.8c-0.5-1.2-0.9-2.5-1.3-3.8c-0.1-0.4,0-0.7,0.2-1.1c0-0.1,0-0.1,0.1-0.2C18.9,30.7,20.8,30.1,22.7,29.5z"
          />
          <path
              fill="#3FB991"
              d="M18.9,37.1c1.9-0.7,3.8-1.3,5.7-2c0.4,1.2,0.9,2.3,1.2,3.5c0.5,1.8-0.4,3.4-2.1,3.9c-1.5,0.5-3.1-0.4-3.7-2C19.6,
              39.4,19.2,38.2,18.9,37.1z"
          />
          <path
              fill="#65861C"
              d="M27,20.3c-0.6-1.8-1.3-3.6-1.9-5.4c0-0.1,0-0.1,0.1-0.2c0.3-0.4,0.6-0.8,1.1-1c1.1-0.4,2.2-0.8,3.3-1.1c0.5-0.1,0.9-0.2,1.3,0.1c0.1,0,
              0.1,0.1,0.2,0.1c0.3,0.1,0.6,0.2,0.7,0.5c0.5,1.3,1,2.7,1.3,4c0.1,0.3-0.1,0.6-0.2,0.8c0,0.1,0,0.1-0.1,0.2C30.9,19,29.1,20,27,20.3z"
          />
          <path
              fill="#E8A721"
              d="M30.9,12.8c-1.9,0.6-3.9,1.3-5.8,1.9c-0.4-1.1-0.8-2.2-1.1-3.4c-0.5-1.7,0.3-3.3,1.9-3.9c1.6-0.6,3.2,0.2,3.9,1.9C30.3,10.6,30.6,
              11.7,30.9,12.8z"
          />
          <path
              fill="#3FB991"
              d="M12.7,18.8c-0.3-1-0.7-2-1-3c-0.5-1.8,0.2-3.5,1.8-4.1c1.7-0.6,3.3,0.3,4,2.1c0.4,1,0.7,2.1,1,3.1c-0.1,0-0.1,0-0.1,0.1c-0.1,
              0.2-0.1,0.6-0.3,0.7c-1.7,0.7-3.3,1.7-5.2,1.5C12.8,19.1,12.7,18.9,12.7,18.8z"
          />
          <path
              fill="#E01664"
              d="M35.1,25.1c1.1-0.4,2.2-0.8,3.4-1.1c1.8-0.5,3.4,0.2,3.9,1.8c0.6,1.6-0.1,3.1-1.9,3.8c-1.1,0.4-2.3,0.8-3.5,
              1.2c0-0.1-0.1-0.1-0.1-0.2c-0.3-0.1-0.6-0.2-0.7-0.5c-0.6-1.4-1-2.8-1.4-4.2c-0.1-0.3,0.1-0.5,0.2-0.7C35.1,25.2,35.1,25.2,35.1,25.1z"
          />
          <path
              fill="#6FCADB"
              d="M12.7,18.8c0.1,0.1,0.1,0.2,0.2,0.2c0.4,0.2,0.7,0.5,0.8,0.9c0.4,1.1,0.8,2.3,1.1,3.4c0.1,0.4,0.1,0.8-0.1,1.2c0,0.1,0,0.2,0,
              0.2c-1,0.3-2,0.6-3,0.9c-2,0.6-3.6-0.1-4.1-1.8c-0.6-1.7,0.3-3.2,2.2-4C10.7,19.6,11.9,19.6,12.7,18.8z"
          />
          <path
              fill="#E01664"
              d="M16.9,31.4c0.6,1.9,1.2,3.7,1.8,5.6c-1.1,0.4-2.2,0.9-3.3,1.2c-1.6,0.5-3.2-0.4-3.7-1.8c-0.5-1.5,0.2-3.2,1.7-3.9C14.5,
              32.1,15.7,31.8,16.9,31.4z"
          />
          <path
              fill="#6FCADB"
              d="M33,18.3c-0.8-1.7-1.3-3.5-1.8-5.4c1.1-0.6,2.3-1,3.6-1.3c1.6-0.3,3.1,0.6,3.5,2c0.4,1.4-0.3,2.9-1.8,3.5C35.3,17.7,34.2,18.1,33,18.3z"
          />
          <path
              fill="#F4F5F6"
              d="M20.6,22.6c2.2-0.7,4.3-1.4,6.5-2.1c0.8,2.2,1.6,4.4,2.2,6.6c-2.1,0.7-4.3,1.4-6.4,2.2c-0.8-2.2-1.5-4.3-2.3-6.5C20.4,
              22.7,20.5,22.7,20.6,22.6z"
          />
          <path
              fill="#1B947D"
              d="M20.6,22.6c0,0.1,0,0.1-0.1,0.2c-1.5,0.3-3,1-4.4,1.4c-0.4,0.1-0.9,0.2-1.3,0.3c-0.7-1.8-1.4-3.6-1.8-5.6c1.8-0.7,
              3.7-1.3,5.5-2c0.9,1.3,1.1,2.9,1.6,4.3C20.2,21.8,20.4,22.2,20.6,22.6z"
          />
          <path
              fill="#CD0E0C"
              d="M35.1,25.3c0.8,1.8,1.3,3.6,1.9,5.4c-1.8,1-3.8,1.5-5.7,2c-0.7-1.8-1.4-3.6-1.8-5.5C31.2,26.4,33.1,25.8,35.1,25.3z"
          />
        </g>
      </svg>
    )
  }
}